export class Config {
  get() {
    return {
      domain: 'penninehelicopters.co.uk',
      title: 'Pennine Helicopters',
      currency: 'gbp',
      map: {
        zoom: 10,
        center: {
          lat: 53.934927,
          lng: -2.407734,
        },
        bounds: [
          {lng: -11.0303, lat: 49.838},
          {lng: 2.0654, lat: 59.6677},
        ],
      },
      destinations: {
        maximum: 2,
      },
      passengers: {
        min: 1,
        max: 10,
      },
      costs: {
        minimum: {
          default: 1250,
        },
      },

      routeTypes: {
        tour: {
          link: {
            href: 'https://www.penninehelicopters.co.uk/helicopter-experience/',
            text: 'View Scheduled Tours from £110',
          },
        },
      },

      links: {
        contact: {
          pretext: 'Need help? Call our friendly team on<br>',
          href: 'tel:+441457877833',
          text: '01457 877 833',
          icon: 'phone',
        },
      },
    }
  }
}
